export const MAX_API_KEYS = 5;

export const COUNTRY_FLAGS_URL = 'https://resources.datanomik.com/flags/';

export const DATANOMIK_CONTACT_US = {
  es: 'https://www.datanomik.com/es/contactar.html',
  pt: 'https://www.datanomik.com/pt/contato.html',
  en: 'https://www.datanomik.com/en/contact-us.html',
};
